import React from 'react';
import {withRouter} from "react-router";
import {Link} from 'react-router-dom';

import {Button} from "reactstrap";
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import ReCAPTCHA from "react-google-recaptcha";

import API from "@beardeddevops/react.api";
import APPCONFIG from 'constants/Config';
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import {locationHasModule} from "../../../components/Utilities";

/**
 *  @property {Accounts_Object} state
 *  @property {object} model
 *  @property {Accounts_Properties} model.properties
 *  @property {Accounts_Is} model.is
 *  @property {Accounts_Has} model.has
 */
class Login extends Framework.Components.Object {

	constructor(props) {
		super(props, Types.Accounts._name);
		this.model.requestType = API.RequestType.READ;
		this.recaptchaRef = React.createRef();
		this.brand = APPCONFIG.brand;
		this.shouldAutoLoad = false;
	}

	handleSubmit = async event => {
		if (typeof event !== 'undefined') event.preventDefault();
		// if (APPCONFIG.settings.isProductionAPI()) {
		// 	this.state.g_recaptcha_response = this.recaptchaRef.current.getValue();
		//
		// 	//bypass recaptcha for Dev
		// 	let url = window.location.href;
		// 	if(url === "https://app.fflboss.com/login") {
		// 		if (!this.state.g_recaptcha_response) {
		// 			return false;
		// 		}
		// 	}
		// }
		this.setState({loading: true});
		if (this.handleProcess(null, API.RequestType.READ)) {
			//if they toggled yes for kiosk, it will pop up the kiosk mode modal that's in NavLeftList componentDidMount
			window.localStorage.setItem('kioskLogin', this.state.kiosk);

			let data = await this.model.submit(this, API.RequestType.READ);

			//if module acquisitions, take them to one_page, else dashboard
			if(data.manual_module_4473){
				this.props.history.push('/dispositions/one_page');
			} else {
				this.props.history.push('/dashboard');
			}

		} else {
			this.setState({loading: false});
		}
		return false;
	};

	onChange = () => {
	};

	// noinspection JSMethodCanBeStatic
	onExpired() {
	}

	handleKeyPress = (event) => {
		if (event.key === 'Enter') {
			this.handleSubmit();
		}
	}

	render() {
		/** @type {Accounts_Properties} properties */
		let properties = this.model.properties;
		/** @type {Accounts_Object} object */
		let object = this.state;
		let brand = this.brand;
		return (
			<div className="body-inner"
			     tabIndex={0}
			     onKeyDown={this.handleKeyPress}>
				<Card>
					<CardContent style={{paddingBottom: 0}}>
						<section className="logo text-center">
							<h1>{brand}</h1>
						</section>

						<fieldset>
							<div className="form-group">
								<Framework.Elements.TextField
									value={object.email}
									error={object.email_error}
									property={properties.email}
									update={this.handleTextFieldPropertyUpdate}
									variant={"standard"}
								/>
							</div>
							<br/>
							<div className="form-group">
								<Framework.Elements.TextField
									value={object.password}
									error={object.password_error}
									property={properties.password}
									update={this.handleTextFieldPropertyUpdate}
									variant={"standard"}
									type={"password"}
								/>
							</div>
							<br/>
						</fieldset>

						<div className={'form-group'}>
							<div>
								<span>Log in to Kiosk-Mode</span>
								<div style={{float: 'right'}}>
									<Framework.Elements.ButtonSwitch
										property={properties.kiosk}
										value={object.kiosk}
										error={object.kiosk_error}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
							</div>
							<br />
						</div>

						{APPCONFIG.settings.isProductionAPI() &&
						<div style={{textAlign: 'center', paddingTop: '10px'}} data-cy={"recaptcha"}>
							<ReCAPTCHA
								ref={this.recaptchaRef}
								sitekey={window.Cypress ? "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI" : APPCONFIG.reCAPTCHA}
								onChange={this.onChange}
								name={"recaptcha"}
								onExpired={this.onExpired.bind(this)}
								style={{
									display: 'inline-block'
								}}
							/>
						</div>}

					</CardContent>
					<CardActions className={'justify-content-between align-items-end'}>
						<Button onClick={this.handleSubmit} type={"submit"} id={"button-login"} color="primary" size={"md"}
						        block={false}>Login</Button>
					</CardActions>
				</Card>
				<div className="additional-info">
					<span style={{'color': '#909090'}}>Version {process.env.version} | {APPCONFIG.copyright}-{APPCONFIG.year} © <a className="brand" target="_blank" href={APPCONFIG.productLink} style={{'color': '#525252'}}>{APPCONFIG.brand}</a></span>
					<br/>
					<Link to="/register" style={{'color': '#525252'}}>Sign up</Link>
					<span className="divider-h" style={{'borderRightColor': '#525252'}}/>
					<Link to="/forgot-password" style={{'color': '#525252'}}>Forgot your password?</Link>
				</div>

			</div>
		);
	}
}

const LoginRoute = withRouter(Login);
const Page = () => (
	<div className="page-login">
		<div className="main-body">
			<div key="1">
				<LoginRoute/>
			</div>
		</div>
	</div>
);

export default Page;
